import React from 'react';
import { Button } from '../ui/Button';
import { FadeIn } from '../ui/FadeIn';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('offer-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-screen flex flex-col items-center justify-center pt-20 pb-16 px-4 md:px-8 overflow-hidden bg-dark-900" data-id="element-63">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-64" />

      <div className="max-w-5xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-65">
        <FadeIn className="order-2 lg:order-1 text-center lg:text-left" data-id="element-66">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-67">
            EL ESPEJO ROTO
            <span className="block text-2xl md:text-3xl mt-4 text-offwhite font-sans font-light" data-id="element-68">
              El fin del hechizo narcisista. Sistema de reconstrucción
              emocional.
            </span>
          </h1>

          <p className="text-lg md:text-xl text-offwhite/80 mb-8 font-light leading-relaxed" data-id="element-69">
            Recupera tu identidad, regula tu sistema nervioso y rompe el vínculo
            de trauma para siempre.
          </p>

          <div className="bg-dark-800/50 border border-gold/20 p-6 rounded-lg mb-10 backdrop-blur-sm" data-id="element-70">
            <h2 className="text-xl md:text-2xl font-serif text-gold-light mb-0" data-id="element-71">
              Deja de cuestionar tu cordura, desactiva la ansiedad constante y
              recupera la mujer que el trauma intentó borrar.
            </h2>
          </div>

          <Button onClick={scrollToOffer} className="w-full md:w-auto" data-id="element-72">
            RECLAMA TU IDENTIDAD AHORA
          </Button>
          <p className="text-sm text-offwhite/50 mt-4 font-light" data-id="element-73">
            Acceso inmediato tras la compra. Tu privacidad es nuestra prioridad.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} className="order-1 lg:order-2 flex justify-center" data-id="element-74">
          <div className="relative w-full max-w-md" data-id="element-75">
            {/* Image glow effect */}
            <div className="absolute inset-0 bg-gold/20 blur-[60px] rounded-full" data-id="element-76" />
            <img src="https://cdn.magicpatterns.com/uploads/1rjF1Jk5DwbZxcJKxYhxCt/EL_ESPEJO_ROTO2.png" alt="El Espejo Roto - Sistema de reconstrucción emocional" className="relative z-10 w-full h-auto object-contain drop-shadow-2xl" data-id="element-77" />
          </div>
        </FadeIn>
      </div>
    </section>;
}